import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { TopBar } from "@/components/Shell";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function MerchantSettings() {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/merchant/store").then(({ data }) => setS(data)).catch(() => {}); }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/merchant/store", {
        opening_hours: s.opening_hours,
        delivery_fee: parseFloat(s.delivery_fee) || 0,
        prep_time: parseInt(s.prep_time, 10) || 0,
        bank_name: s.bank_name, bank_agency: s.bank_agency, bank_account: s.bank_account, pix_key: s.pix_key,
      });
      setS(data);
      toast.success("Configurações salvas!");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    }
  };

  if (!s) return <div className="p-6 text-sm text-gray-500">Carregando…</div>;

  return (
    <div data-testid="merchant-settings-page" className="pb-8">
      <TopBar subtitle="Configurações da loja" />
      <div className="px-4 pt-5 space-y-4">
        <h1 className="font-display text-2xl font-extrabold">{s.name}</h1>

        <Field label="Horário de funcionamento" testId="settings-hours-input" value={s.opening_hours || ""} onChange={(v) => setS({ ...s, opening_hours: v })} />
        <Field label="Taxa de entrega (R$)" testId="settings-delivery-fee-input" value={s.delivery_fee} onChange={(v) => setS({ ...s, delivery_fee: v })} />
        <Field label="Tempo médio de preparo (min)" testId="settings-prep-time-input" value={s.prep_time} onChange={(v) => setS({ ...s, prep_time: v })} />

        <h2 className="font-display font-bold text-base pt-3">Dados bancários para repasse</h2>
        <Field label="Banco" testId="settings-bank-input" value={s.bank_name || ""} onChange={(v) => setS({ ...s, bank_name: v })} />
        <Field label="Agência" testId="settings-agency-input" value={s.bank_agency || ""} onChange={(v) => setS({ ...s, bank_agency: v })} />
        <Field label="Conta" testId="settings-account-input" value={s.bank_account || ""} onChange={(v) => setS({ ...s, bank_account: v })} />
        <Field label="Chave Pix" testId="settings-pix-input" value={s.pix_key || ""} onChange={(v) => setS({ ...s, pix_key: v })} />

        <Button data-testid="save-settings-button" onClick={save} className="w-full h-12 rounded-xl gf-gradient text-white font-bold gf-press">
          Salvar configurações
        </Button>
      </div>
    </div>
  );
}

const Field = ({ label, value, onChange, testId }) => (
  <div>
    <Label className="text-xs text-gray-500">{label}</Label>
    <Input data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className="h-11 rounded-xl mt-1" />
  </div>
);
